var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDistalRotation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1.91667V1H6V1.91667H5ZM5 5.58333V3.75H6V5.58333H5ZM5 9.25V7.41667H6V9.25H5ZM5 12.9167V11.0833H6V12.9167H5ZM5 16.5833V14.75H6V16.5833H5ZM5 20.25V18.4167H6V20.25H5ZM5 23V22.0833H6V23H5Z",
    fill: "#647B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.92092C7.13002 5.10979 9.06508 4.99999 11.0001 5C14.1752 5.00001 17.3502 5.29564 16.9687 8.5C16.958 8.59025 16.9473 8.68082 16.9365 8.77168C16.375 13.5009 15.7222 19 11.6737 19H10.3263C7.90578 19 6.69907 17.0343 6 14.4427V5.92092Z",
    fill: "#C9D2D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0059 8.01953C18.4179 8.30195 19.7524 8.93098 20.4133 9.85641C21.1016 10.8201 21.1874 11.9977 20.6501 13.0724C20.1333 14.1058 19.091 14.9596 17.6699 15.5489C16.2379 16.1426 14.3512 16.5001 12.0059 16.5001V18.5001L8.00586 15.5001L12.0059 12.5001V14.5001C14.1602 14.5001 15.7733 14.1701 16.9038 13.7014C18.0452 13.2281 18.6279 12.6445 18.8613 12.1779C19.074 11.7525 19.0349 11.3676 18.7858 11.0188C18.5093 10.6317 17.8977 10.1983 16.8098 9.98069L17.0059 8.01953Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistalRotation);
export default __webpack_public_path__ + "static/media/distal-rotation.3bbebe8c.svg";
export { ForwardRef as ReactComponent };